import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2482e076"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TargetDataBox" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "TargetData-table" }
const _hoisted_4 = { class: "paginationCont" }
const _hoisted_5 = { style: {"flex":"auto"} }
const _hoisted_6 = { class: "dialog-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "dialog-footer" }

import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance,
  toRaw,
  nextTick,
  watch,
  onUnmounted,
  onActivated,
  onDeactivated,
  computed
} from "vue";
import {
  getTargetPage,
  appTargetDetail,
  getAccessAly,
  getConcerteduserList,
  saveTarget,
  reCompares,
  getCompanyOption,
  getTencentCloudConfig,
  getVerifyEnumByOrder
} from "@/views/VerificationData/api.js";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadProps,
  UploadUserFile,
  FormInstance,
  FormRules,
} from "element-plus";
import { Search, RefreshRight, Right } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  targetAudit,
  completionAudit,
  save,
  cancelExceptionReport,
  targetCompleted,
} from "./api";
import { setField } from "@/utiles/utiles";
import viewDetail from "./viewDetails.vue";
import { useStore } from "vuex";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import { v4 as uuidv4 } from "uuid";
import { useRoute } from "vue-router";
interface targetInfo {
  farmerInfo: {
    farmerName: string;
    idCard: string;
  };
  ossUrl: string;
  cosUrl: string;
  simTarget: any[];
  targetInfo: {
    picInfoVoList: any;
    targetName: string;
    targetType: string;
    subjectBatchName: string;
    videoId: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TargetData',
  setup(__props) {

const store = useStore();
const { proxy }: any = getCurrentInstance();
const verifyTargetOrCollar = ref("EAR_TAG");
let insureDetailId = ref("");
const tableData = ref<any>([]);
const Router = useRouter();
const ruleFormImgRef = ref();
let insureDawer = ref(false);
let dialogFormVisible = ref(false);
const loading = ref(false);
const submitBtn = ref(true);
const reCompareLoading = ref(false);
const timer = ref(null); // 定时器引用
const columns = reactive({
  COLLECTING: [
    { label: "标的编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    { label: "采集人", prop: "userName", width: "auto" },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "异常上报",
      prop: "exceptionReportStatus",
      width: "auto",
      dic: {
        "1": "处理中",
        "2": "已处理",
      },
    },
  ],
  AuditPage: [
    { label: "标的编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    { label: "采集人", prop: "userName", width: "auto" },
    {
      label: "风筛结果",
      prop: "targetStatus",
      width: "auto",
      dic: {
        NORMAL: "唯一标的",
        REPEAT: "疑似重复",
        RELATED: "有关联标的",
      },
    },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "审核确认",
      prop: "insureResult",
      width: "auto",
      dic: {
        NORMAL: "唯一标的",
        REPEAT: "重复标的",
      },
    },
    { label: "审核人", prop: "auditorName", width: "auto" },
    { label: "审核时间", prop: "auditTime", width: "auto" },
    {
      label: "异常上报",
      prop: "exceptionReportStatus",
      width: "auto",
      dic: {
        "1": "处理中",
        "2": "已处理",
      },
    },
  ],
  audited: [
    { label: "标的编号", prop: "targetNo", width: "auto" },
    { label: "登记号", prop: "earOrCollar", width: "auto" },
    { label: "采集人", prop: "userName", width: "auto" },
    { label: "采集时间", prop: "created", width: "auto" },
    {
      label: "审核结果",
      prop: "insureResult",
      width: "auto",
      dic: {
        NORMAL: "唯一标的",
        REPEAT: "重复标的",
      },
    },
    {
      label: "风筛结果",
      prop: "targetStatus",
      width: "auto",
      dic: {
        NORMAL: "唯一标的",
        REPEAT: "疑似重复",
        RELATED: "有关联标的",
      },
    },
    {
      label: "审核岗",
      prop: "auditorName",
      width: "auto",
    },
    { label: "审核时间", prop: "auditTime", width: "auto" },
  ],
});
const targetType = ref<any>("");
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector(".TargetData-table");
  if (!tableContainer) {
    console.log("未找到表格容器");
    return;
  }

  const allRows = document.querySelectorAll(".el-table__row");
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector(".el-table__header");
  const headerHeight = tableHeader
    ? tableHeader.getBoundingClientRect().height
    : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return; // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
const queryForm = reactive({
  condition: {
    orderId: "",
    caseId: "",
    targetStatus: null,
    insureResult: null,
    type: "SUBJECT",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});

const rules = reactive<FormRules>({
  compCode: [
    { required: true, message: "请输入租户代码", trigger: "blur" },
    { pattern: /^[a-zA-Z0-9]+$/, message: "只允许大小写字母和数字" },
  ],
  earNo: [
    { required: true, message: "请输入登记号", trigger: "blur" },
    {
      validator: (rule, value, callback) => {

        if (verifyTargetOrCollar.value === "NONE") {
          callback();
        } else if (!value) {
          callback(new Error("请输入登记号"));
        } else if (
          verifyTargetOrCollar.value === "COLLAR" &&
          value.length > 30
        ) {
          callback(new Error("登记号长度不能超过30位"));
        } else if (
          verifyTargetOrCollar.value === "EAR_TAG" &&
          value.length > 32
        ) {
          callback(new Error("登记号长度不能超过32位"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
});
let collectList = ref([]);
const rawData = localStorage.getItem("collectDataRow");
const collectDataRow = rawData ? JSON.parse(rawData) : {};
const OSS = require("ali-oss");
const COS = require("cos-js-sdk-v5");
let aliossData = {};
let tenCosData = {};
const ruleFormRef = ref<FormInstance>();
let form = reactive({
  creatorId: collectDataRow.creatorId || null,
  verifyTargetOrCollarEnum: "",
  name: "",
  earNo: "",
  collectUser: "",
  livestockAge: null,
  picInfo: [
    {
      picType: "FACE",
      picUrls: [
        {
          url: "",
          cloudServiceType: "2",
        },
      ],
    },
    {
      picType: "LEFT_FACE",
      picUrls: [
        {
          url: "",
          cloudServiceType: "2",
        },
      ],
    },
    {
      picType: "RIGHT_FACE",
      picUrls: [
        {
          url: "",
          cloudServiceType: "2",
        },
      ],
    },
    {
      picType: "NOSE",
      picUrls: [
        {
          url: "",
          cloudServiceType: "2",
        },
      ],
    },
  ],
  targetType: "BEEF",
  type: "SUBJECT",
  targetCreatedTime: "",
  orderId: "",
});

const formLabelWidth = "120px";
const uploadUrl = "";
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisible.value = true;
};
const fileList = ref<UploadUserFile[]>([]);
let auditForm = reactive({
  targetId: "",
  auditStatus: "",
  auditTargetId: "",
  type: "SUBJECT",
});

const targetInfo = reactive<targetInfo>({
  farmerInfo: {
    farmerName: "",
    idCard: "",
  },
  ossUrl: "",
  cosUrl: "",
  simTarget: [],
  targetInfo: {
    picInfoVoList: [],
    targetName: "",
    subjectBatchName: "",
    targetType: "",
    videoId: "",
  },
});
const total = ref(0);
const getStorageKey = () => {
  return `verificationTargetData_${targetType.value}_params`;
};

// 保存查询参数到 sessionStorage
const saveQueryParams = () => {
  const paramsToSave = {
    pageIndex: queryForm.pageIndex,
    pageSize: queryForm.pageSize,
    targetStatus: queryForm.condition.targetStatus,
    insureResult: queryForm.condition.insureResult,
  };
  sessionStorage.setItem(getStorageKey(), JSON.stringify(paramsToSave));
};

// 从 sessionStorage 恢复查询参数
const restoreQueryParams = () => {
  const savedParams = sessionStorage.getItem(getStorageKey());
  if (savedParams) {
    const parsedParams = JSON.parse(savedParams);
    queryForm.pageIndex = parsedParams.pageIndex || 1;
    queryForm.pageSize = parsedParams.pageSize || defaultPageSize.value;

    if (
      targetType.value === "audited" &&
      parsedParams.insureResult !== undefined
    ) {
      queryForm.condition.insureResult = parsedParams.insureResult;
    }

    if (
      targetType.value === "AuditPage" &&
      parsedParams.targetStatus !== undefined
    ) {
      queryForm.condition.targetStatus = parsedParams.targetStatus;
    }

    return true; // 表示恢复了参数
  }
  return false; // 表示没有恢复参数
};
onActivated(() => {
  const jsonStr = sessionStorage.getItem('targetData') || "{}";
  const targetData = JSON.parse(jsonStr);
  console.log('targetData', targetData);

  // 获取当前路由参数
  const newOrderId = toRaw(Router).currentRoute.value.query.id || targetData.id || "";
  const newTargetType = toRaw(Router).currentRoute.value.query.name || targetData.name || "";

  // 检查是否切换了案件或页面类型
  const isSameContext =
    newOrderId === queryForm.condition.orderId &&
    newTargetType === targetType.value;

  // 更新当前值
  queryForm.condition.orderId = newOrderId;
  targetType.value = newTargetType;
  const isReComparing =
    localStorage.getItem(`isReComparing:${queryForm.condition.orderId}`) ===
    "true";
  console.log("进入了onActivated", `isReComparing:${queryForm.condition.orderId}`, localStorage.getItem(`isReComparing:${queryForm.condition.orderId}`));

  if (isReComparing) {
    fetchData(queryForm.condition.orderId);
    startPolling(queryForm.condition.orderId);
  } else {
    setLoadingState(queryForm.condition.orderId, false);
    localStorage.removeItem(`isReComparing:${queryForm.condition.orderId}`);
  }

  if (isSameContext) {
    // 如果是相同上下文，尝试恢复参数
    const restored = restoreQueryParams();
    if (restored) {
      onSearch(false); // 使用恢复的参数查询
      return;
    }
  }



  // 如果是新上下文或没有恢复参数，执行初始查询
  onSearch(true);
});
// 存储所有订单的 loading 状态
const orderLoadingStates = ref({});

// 获取或初始化当前订单的 loading 状态
const getLoadingState = (orderId) => {
  if (!orderLoadingStates.value[orderId]) {
    orderLoadingStates.value[orderId] = false; // 默认未加载
  }
  return orderLoadingStates.value[orderId];
};

// 更新指定订单的 loading 状态
const setLoadingState = (orderId, isLoading) => {
  orderLoadingStates.value[orderId] = isLoading;
};
// 存储所有订单的定时器
const timers = {};

// 清理定时器
const cleanupTimer = (orderId) => {
  if (timers[orderId]) {
    clearInterval(timers[orderId]);
    delete timers[orderId];
    console.log(`订单 ${orderId} 的定时器已清除`);
  }
};

// 轮询逻辑
const fetchData = async (orderId) => {
  try {
    const res = await targetCompleted({
      orderOrCaseId: orderId,
      type: "SUBJECT",
    });
    if (res === true) {
      setLoadingState(orderId, false);
      cleanupTimer(orderId);
      localStorage.removeItem(`isReComparing:${orderId}`);
      onSearch(true);
    } else {
      setLoadingState(orderId, true);
    }
  } catch (error) {
    console.error(`订单 ${orderId} 轮询失败:`, error);
  }
};

// 启动轮询
const startPolling = (orderId) => {
  if (!orderId || timers[orderId]) return;
  timers[orderId] = setInterval(() => fetchData(orderId), 3000);
  console.log(`订单 ${orderId} 的定时器已启动`);
};

onDeactivated(() => {
  console.log("进入了onDeactivated");
  cleanupTimer(queryForm.condition.orderId);
});

onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  const jsonStr = sessionStorage.getItem('targetData') || "{}";
  const targetData = JSON.parse(jsonStr);
  console.log('targetData', targetData);
  queryForm.condition.orderId = toRaw(Router).currentRoute.value.query.id || targetData.id || "";
  if (queryForm.condition.orderId) {
    const isReComparing =
      localStorage.getItem(`isReComparing:${queryForm.condition.orderId}`) ===
      "true";
    if (isReComparing) {
      fetchData(queryForm.condition.orderId);
      startPolling(queryForm.condition.orderId);
    } else {
      setLoadingState(queryForm.condition.orderId, false);
      localStorage.removeItem(`isReComparing:${queryForm.condition.orderId}`);
    }
  }
  targetType.value = toRaw(Router).currentRoute.value.query.name || targetData.name || "";
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  // onSearch(true);
  getAccessAlyFn();
  getTencentFn();
  // generateID();
  collectors();
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener("resize", debouncedCalculate);
});
watch(
  tableData,
  () => {
    if (tableData.value.length > 0) {
      // 只在有数据时才重新计算
      nextTick(() => {
        calculateTableRows();
      });
    }
  },
  { immediate: false }
);

onUnmounted(() => {
  // cleanupTimer();
  window.removeEventListener("resize", calculateTableRows);
  userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      userManuallySetPageSize.value = false;
      fn.apply(this, args);
    }, delay);
  };
};
const collectors = () => {
  const rawData = localStorage.getItem("collectDataRow");
  const collectDataRow = rawData ? JSON.parse(rawData) : {};
  console.log("collectDataRow.id", collectDataRow);

  if (collectDataRow?.id) {
    getConcerteduserList(collectDataRow.id)
      .then((res) => {
        // 在 Promise 解析后，将结果赋值给 collectList.value
        console.log("collectDataRowres", res);

        collectList.value = res;
        form.collectUser = ''
        if (collectList.value.length === 1) {
          form.collectUser = collectList.value[0].id;
        }
      })
      .catch((error) => {
        // 处理可能的错误
        console.error("获取协同用户列表失败:", error);
      });
  }

  // }
  console.log("collectList.value", collectList.value);
};
const getPlaceholder = () => {
  switch (verifyTargetOrCollar.value) {
    case "EAR_TAG":
      return "请输入登记号（最多32位）";
    case "COLLAR":
      return "请输入登记号（最多30位）";
    default:
      return "请输入编号";
  }
};
const generateID = () => {
  if (verifyTargetOrCollar.value === "NONE") {
    const timestamp = new Date()
      .toISOString()
      .replace(/[^0-9]/g, "")
      .slice(0, 14);
    let randomNum = uuidv4().replace(/-/g, "").slice(0, 4);
    form.earNo = timestamp + randomNum.toString().padStart(4, "0");
  }
};
watch(verifyTargetOrCollar, (newValue) => {
  if (newValue === "NONE") {
    form.earNo = "";
  } else {
    form.earNo = "";
  }
});
const dateTime = () => {
  const now = new Date();
  const year = now.getFullYear(); // 获取年份
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 获取月份，并从1开始计数，补零
  const date = now.getDate().toString().padStart(2, "0"); // 获取日，补零
  const hours = now.getHours().toString().padStart(2, "0"); // 获取小时，补零
  const minutes = now.getMinutes().toString().padStart(2, "0"); // 获取分钟，补零
  const seconds = now.getSeconds().toString().padStart(2, "0"); // 获取秒钟，补零

  form.targetCreatedTime = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
};
function validatePictures() {
  let atLeastOnePicture = false;
  for (const info of form.picInfo) {
    if (info.picUrls && info.picUrls.length > 0) {
      atLeastOnePicture = true;
      break; // 已经找到至少一张图片，可以退出循环
    }
  }

  return atLeastOnePicture;
}

const submitImg = async (formEl: FormInstance | undefined) => {
  dateTime();
  form.orderId = collectDataRow.id;
  form.creatorId = collectDataRow.creatorId;
  if (!formEl) return;
  const result: boolean = validatePictures();
  if (!result) {
    ElMessage({
      message: "至少有一张图片",
      type: "error",
    });
    return;
  }

  interface PicInfo {
    picType: string;
    picUrls: { url: string; cloudServiceType: string }[];
  }

  const picInfo: PicInfo[] = form.picInfo.map((n) => {
    const { picType, picUrls } = n;
    let item: PicInfo = { picType, picUrls: [] };
    if (picUrls && picUrls.length) {
      item.picUrls = picUrls.map((urlObj: any) => ({
        url: urlObj.url,
        cloudServiceType: urlObj.cloudServiceType || "1",
      }));
    }
    return item;
  });

  // 包含所有数据
  const formData = {
    ...form,
    picInfo,
  };

  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      saveTarget(formData)
        .then((res: any) => {
          ElMessage({
            message: "新增标的成功",
            type: "success",
          });
          onSearch(true);
          formEl && formEl.resetFields();
          dialogFormVisible.value = false;
          initForm();
        })
        .catch(() => { });
    } else {
      console.log("表单验证失败", fields);
    }
  });
};
// 定义图片上传成功后的处理函数，接受一个字段名作为参数
function handleremove(picType, file, fileList) {
  // 找到对应的 picType
  const picItem = form.picInfo.find((item) => item.picType === picType);
  if (picItem) {
    // 假设我们需要保留 fileList 中的 URL，并且从 picItem.picUrls 中移除不在 fileList 中的 URL
    // 同时，我们需要确保每个 URL 对象都包含 cloudServiceType 属性
    const newPicUrls = picItem.picUrls
      .filter((picUrl) => fileList.some((file: any) => file.url === picUrl.url))
      .map((picUrl: any) => ({
        url: picUrl.url,
        cloudServiceType: picUrl.cloudServiceType, // 确保保留 cloudServiceType 属性
      }));

    picItem.picUrls = newPicUrls; // 更新 picUrls 数组
  }
}
const getAccessAlyFn = () => {
  getAccessAly().then((res: any) => {
    localStorage.setItem("alioss", JSON.stringify(res));
    aliossData = res || JSON.parse(localStorage.getItem("alioss") || "");
  });
};
const getTencentFn = () => {
  getTencentCloudConfig().then((res: any) => {
    localStorage.setItem("tenCos", JSON.stringify(res));
    tenCosData = res || JSON.parse(localStorage.getItem("tenCos") || "");
  });
};
// 工厂函数用于生成具有特定fieldId的上传请求处理函数
const uploadRequestFactory = (fieldId) => {
  return (options) => {
    const { file } = options; // 从options中提取文件对象
    UploadFilePublic(file, fieldId); // 调用实际的上传函数
  };
};
/*const UploadFilePublic = (file, fieldId: string) => {
  // type用来判断 是图片还是视频
  // suffix是后缀名
  let uuid = uuidv4().replace(/-/g, ""); // 生成UUID并去掉所有'-'
  let fileName = uuid + file.name.substr(file.name.lastIndexOf(".")); // 保留原文件扩展名 ;
  let client = new OSS({
    region: aliossData.region,
    accessKeyId: aliossData.accessKeyId,
    accessKeySecret: aliossData.accessKeySecret,
    bucket: aliossData.bucketName,
    endpoint: aliossData.endpoint,
  });
  try {
    // 上传文件到指定文件夹
    const result = client.put(aliossData.catalogue + fileName, file);
    result.then((res) => {
      console.log("上传图片res", res);
      form.picInfo.forEach((picItem) => {
        if (picItem.picType === fieldId) {
          picItem.picUrls.push(fileName);
        }
      });
    });
  } catch (e) {
    console.error("上传失败:", e);
  }
};*/
const UploadFilePublic = (file, fieldId) => {
  // type用来判断 是图片还是视频
  // suffix是后缀名
  let uuid = uuidv4().replace(/-/g, ""); // 生成UUID并去掉所有'-'
  let fileName = uuid + file.name.substr(file.name.lastIndexOf(".")); // 保留原文件扩展名

  // 腾讯云COS配置
  const cos = new COS({
    getAuthorization: function (options, callback) {
      callback({
        TmpSecretId: tenCosData.tmpSecretId,
        TmpSecretKey: tenCosData.tmpSecretKey,
        SecurityToken: tenCosData.sessionToken,
        StartTime: tenCosData.startTime,
        ExpiredTime: tenCosData.expiredTime, // 时间戳，单位秒
      });
    },
  });

  try {
    // 上传文件到指定文件夹
    cos.uploadFile(
      {
        Bucket: tenCosData.bucket + "-" + tenCosData.appId,
        Region: tenCosData.region,
        Key: fileName,
        Body: file,
        onProgress: function (progressData) {
          console.log(JSON.stringify(progressData));
        },
      },
      (err, data) => {
        if (err) {
          console.error("上传失败:", err);
          return;
        }
        console.log("上传成功:", data);

        // 更新表单中的文件信息
        form.picInfo.forEach((picItem) => {
          if (picItem.picType === fieldId) {
            picItem.picUrls.push({
              cloudServiceType: "2",
              url: fileName,
            });
          }
        });
      }
    );
  } catch (e) {
    console.error("上传过程中发生错误:", e);
  }
};
const initForm = () => {
  form.picInfo = [
    {
      picType: "FACE",
      picUrls: [],
    },
    {
      picType: "LEFT_FACE",
      picUrls: [],
    },
    {
      picType: "RIGHT_FACE",
      picUrls: [],
    },
    {
      picType: "NOSE",
      picUrls: [],
    },
  ];
};
const createTarget = () => {
  form.picInfo = [
    {
      picType: "FACE",
      picUrls: [],
    },
    {
      picType: "LEFT_FACE",
      picUrls: [],
    },
    {
      picType: "RIGHT_FACE",
      picUrls: [],
    },
    {
      picType: "NOSE",
      picUrls: [],
    },
  ];
  form.earNo = ''
  console.log("picInfoform", form);
  // generateID();
  collectors()
  dialogFormVisible.value = true;
};
const submitAubit = () => {
  loading.value = true;
  completionAudit(queryForm.condition.orderId)
    .then((res: any) => {
      ElMessage({
        message: "已完成审核",
        type: "success",
      });
      onSearch(true);
    })
    .catch((err) => { })
    .finally(() => {
      loading.value = false;
    });
};
const appTargetDetailFn = (id: any) => {
  appTargetDetail(id).then(async (res: any) => {
    for (let key in res) {
      const k = key as keyof targetInfo;
      if (res[k]) setField(targetInfo, k, res[k]);
    }
    targetInfo.targetInfo.videoId =
      targetInfo.ossUrl + targetInfo.targetInfo.videoId;
    if (targetInfo.simTarget) {
      targetInfo.simTarget.forEach((item) => {
        item.videoId = targetInfo.ossUrl + item.videoId;
      });
      // if (targetType == 'audited') {
      //   targetInfo.simTarget = targetInfo.simTarget.filter(v => v.id == targetInfo.targetInfo.acceptSimilarId)
      // }
    } else {
      targetInfo.simTarget = [];
    }
    console.log("targetInfo", targetInfo);
    isShowSure(!!targetInfo.simTarget.length);
    setForm(res.targetInfo);
    sortPicInfoVoList();
    sortedTargetInfoList();
    sortSimilarTarget();
    console.log("targetInfo.targetInfo", targetInfo.targetInfo);
    auditForm.targetId = id;
    await nextTick();
    insureDawer.value = true;
  });
};
// 定义排序顺序
const sortOrder = {
  FACE: 1,
  NOSE: 2,
  LEFT_FACE: 3, // 如果LEFT_FACE不需要排序，可以移除这一行和相关的逻辑
  RIGHT_FACE: 4, // 如果RIGHT_FACE不需要排序，可以移除这一行和相关的逻辑
};
const sortSimilarTarget = () => {
  if (targetInfo.simTarget) {
    targetInfo.simTarget.map((target) => {
      if (target.picInfoVoList && Array.isArray(target.picInfoVoList)) {
        target.picInfoVoList.sort((a, b) => {
          const orderA = sortOrder[a.picType] || Infinity;
          const orderB = sortOrder[b.picType] || Infinity;
          return orderA - orderB;
        });
      }
    });
  }
};
// 使用map和sort方法对数组进行处理
const sortedTargetInfoList = () => {
  if (targetInfo.payTarget) {
    targetInfo.payTarget.map((target) => {
      if (target.picInfoVoList && Array.isArray(target.picInfoVoList)) {
        target.picInfoVoList.sort((a, b) => {
          const orderA = sortOrder[a.picType] || Infinity;
          const orderB = sortOrder[b.picType] || Infinity;
          return orderA - orderB;
        });
      }
    });
  }
};
// 创建一个方法来排序数组
const sortPicInfoVoList = () => {
  if (
    targetInfo.targetInfo &&
    Array.isArray(targetInfo.targetInfo.picInfoVoList)
  ) {
    // 创建一个新数组来触发响应性更新
    targetInfo.targetInfo.picInfoVoList = reactive([
      ...targetInfo.targetInfo.picInfoVoList,
    ]).sort((a, b) => {
      const orderA = sortOrder[a.picType] || Infinity;
      const orderB = sortOrder[b.picType] || Infinity;
      return orderA - orderB;
    });
  }
};
const setForm = async (targetInfo: any) => {
  await nextTick();
  auditForm = reactive({
    auditStatus:
      targetType == "COLLECTING"
        ? targetInfo.targetStatus
        : targetInfo.insureResult,
    auditTargetId: targetInfo.insureSimilarId,
    targetId: auditForm.targetId,
    type: "SUBJECT",
  });
  console.log("auditForm1", auditForm);
};
const isShowSure = (val: Boolean) => {
  submitBtn.value = val;
};
const goBack = () => {
  console.log("Router", Router);
  // Router.back();
  Router.go(-1);

};
const cancel = () => {
  insureDawer.value = false;
  for (const key in auditForm) {
    auditForm[key] = "";
    auditForm["type"] = "SUBJECT";
  }
};
const onSearch = (type: boolean) => {
  // 重置数据状态
  tableData.value = [];
  if (type) {
    queryForm.pageIndex = 1;
  }
  if (!queryForm.condition.targetStatus) {
    queryForm.condition.targetStatus = null;
  }
  if (!queryForm.condition.insureResult) {
    queryForm.condition.insureResult = null;
  }

  // 保存查询参数
  saveQueryParams();

  if (targetType.value === "audited") {
    queryForm.condition.targetStatus = null;
  } else if (targetType.value === "AuditPage") {
    queryForm.condition.insureResult = null;
  }
  getTargetPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });

  getVerifyEnumByOrder(queryForm.condition.orderId).then((res: any) => {
    console.log("res", res);
    verifyTargetOrCollar.value = res;

    form.verifyTargetOrCollarEnum = res; // 更新表单中的值
  })
};
// 完成审核
const submitAudit = () => {
  console.log("auditForm", auditForm);
  if (!auditForm.auditStatus) {
    ElMessage({
      message: "请先选择审核结果",
      type: "warning",
    });
    return;
  }
  if (auditForm.auditStatus == "REPEAT" && !auditForm.auditTargetId) {
    ElMessage({
      message: "请先选择确认标的",
      type: "error",
    });
    return;
  }
  targetAudit(auditForm).then((res: any) => {
    ElMessage({
      message: "已完成审核",
      type: "success",
    });
    cancel();
    onSearch(true);
  });
};
const resetForm = (formEl: any) => {
  if (!formEl) return;
  console.log(formEl);
  formEl.resetFields();
  sessionStorage.removeItem(getStorageKey());
};
// const viewDetails = (row: any) => {
//   // Router.push({ name: "viewDetails", query: { id: row.id } });
//   appTargetDetailFn(row.id);
// };
const route = useRoute();
const viewDetails = (row: any) => {
  saveQueryParams();
  const routeName = toRaw(Router).currentRoute.value.query.name as string;
  // 检查是否是处理中的异常上报
  if (
    (routeName === "AuditPage" || routeName === "COLLECTING") &&
    row.exceptionReportStatus === "1"
  ) {
    ElMessageBox.confirm(
      "当前标的上报异常处理中尚未反馈处理结果，需直接审核可选择取消上报",
      "提示",
      {
        confirmButtonText: "取消上报",
        cancelButtonText: "等待处理结果",
        type: "warning",
        distinguishCancelAndClose: true,
      }
    )
      .then(() => {
        // 点击"取消上报"的逻辑 - 显示第二层确认框
        ElMessageBox.confirm("是否确定自行审核，取消上报", "提示", {
          confirmButtonText: "确认取消",
          cancelButtonText: "等待处理结果",
          type: "warning",
          distinguishCancelAndClose: true,
        })
          .then(() => {
            // API
            cancelExceptionReport(row.exceptionReportId)
              .then(() => {
                ElMessage.success("取消成功");
                // 正常进入详情页面
                Router.push({
                  name: "updateInsurDetail",
                  query: {
                    id: row.id,
                    name: targetType.value,
                    readonly:
                      targetType.value === "AuditPage" ||
                        targetType.value === "COLLECTING"
                        ? "false"
                        : "true",
                    taskId: row.taskId,
                  },
                });
              })
              .catch((error) => {
                ElMessage.error(
                  "取消上报失败: " + (error.message || "未知错误")
                );
              });
          })
          .catch((action) => {
            // 点击"等待处理结果"
            if (action === "cancel") {
              // 进入页面但隐藏完成审核按钮
              Router.push({
                name: "updateInsurDetail",
                query: {
                  id: row.id,
                  name: targetType.value,
                  readonly:
                    targetType.value === "AuditPage" ||
                      targetType.value === "COLLECTING"
                      ? "false"
                      : "true",
                  taskId: row.taskId,
                  hideAuditButton: "true", // 添加参数标识隐藏按钮
                },
              });
            }
          });
      })
      .catch((action) => {
        // 第一层点击"等待处理结果"
        if (action === "cancel") {
          // 进入页面但隐藏完成审核按钮
          Router.push({
            name: "updateInsurDetail",
            query: {
              id: row.id,
              name: targetType.value,
              readonly:
                targetType.value === "AuditPage" ||
                  targetType.value === "COLLECTING"
                  ? "false"
                  : "true",
              taskId: row.taskId,
              hideAuditButton: "true", // 添加参数标识隐藏按钮
            },
          });
        }
      });
  } else {
    // 非处理中状态，直接跳转
    Router.push({
      name: "updateInsurDetail",
      query: {
        id: row.id,
        name: targetType.value,
        readonly:
          targetType.value === "AuditPage" || targetType.value === "COLLECTING"
            ? "false"
            : "true",
        taskId: row.taskId,
      },
    });
  }
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};
// 重新对比逻辑
const reCompare = () => {
  setLoadingState(queryForm.condition.orderId, true);
  localStorage.setItem(`isReComparing:${queryForm.condition.orderId}`, "true"); // 标记为对比中
  reCompares({ id: queryForm.condition.orderId, type: "INSURANCE" })
    .then(() => {
      ElMessage.success("正在比对中，请稍候");
      onSearch(true);
      startPolling(queryForm.condition.orderId);
    })
    .catch(() => {
      setLoadingState(queryForm.condition.orderId, false);
      localStorage.removeItem(`isReComparing:${queryForm.condition.orderId}`); // 失败时清除标记
    });
};
const userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : null;
const validateInsureConfig = async (typeEnum: string, collectField: string): Promise<boolean> => {
  if (!userInfo?.compCode) {
    console.warn('用户信息中缺少 compCode');
    return false;
  }
  
  try {
    const companyInfoConfigs = await getCompanyOption(userInfo.compCode);
    // 1. 找到类型为 INSURE 的配置项
    const insureConfig = companyInfoConfigs?.verificationCollection?.find(
      item => item.typeEnum === typeEnum
    );
    
    if (!insureConfig) {
      console.warn('未找到 ' + typeEnum + ' 类型的配置');
      return false;
    }
    
    // 2. 获取 companyOptionObj
    const companyOptionObj = insureConfig.companyOptionObj;
    if (!companyOptionObj) {
      console.warn(typeEnum + ' 配置中缺少 companyOptionObj');
      return false;
    }
    
    // 3. 获取 collectFields 数组
    const collectFields = companyOptionObj.collectFields;
    if (!Array.isArray(collectFields) || collectFields.length === 0) {
      console.warn('collectFields 为空或不是数组');
      return false;
    }
    
    // 4. 检查是否包含指定字段
    const hasCollectField = collectFields.some(
      field => field.field === collectField
    );
    
    console.log('是否包含 ' + collectField + ' 字段:', hasCollectField);
    return hasCollectField;
    
  } catch (error: any) {
    console.error("Error fetching company options:", error);
    return false;
  }
};
const showField = ref(false);

onMounted(async () => {
  showField.value = await validateInsureConfig('INSURANCE', 'LIVESTOCK_AGE');
});

return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: queryForm,
        class: "demo-form-inline",
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        "label-width": "90px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_link, { onClick: goBack }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Back)
                    ]),
                    _: 1
                  }),
                  _createTextVNode("返回")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (targetType.value == 'audited')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "审核结果",
                prop: "condition.insureResult"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: queryForm.condition.insureResult,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.insureResult) = $event)),
                    placeholder: "审核结果",
                    class: "unifiedInputBoxWidth",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "唯一标的",
                        value: "NORMAL"
                      }),
                      _createVNode(_component_el_option, {
                        label: "重复标的",
                        value: "REPEAT"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (targetType.value == 'AuditPage')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "风筛结果",
                prop: "condition.targetStatus"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: queryForm.condition.targetStatus,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.targetStatus) = $event)),
                    placeholder: "风筛结果",
                    class: "unifiedInputBoxWidth",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "唯一标的",
                        value: "NORMAL"
                      }),
                      _createVNode(_component_el_option, {
                        label: "疑似重复",
                        value: "REPEAT"
                      }),
                      _createVNode(_component_el_option, {
                        label: "有关联标的",
                        value: "RELATED"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              (targetType.value == 'COLLECTING')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: createTarget
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新建标的")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (targetType.value != 'COLLECTING')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: _unref(Search),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onSearch(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查 询")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshRight),
                      plain: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重 置")
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    (targetType.value == 'AuditPage')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          plain: "",
                          onClick: submitAubit,
                          loading: loading.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完成审核")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (targetType.value === 'AuditPage')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          onClick: reCompare,
                          loading: getLoadingState(queryForm.condition.orderId)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重新对比验标")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { style: {"float":"right"} }, {
            default: _withCtx(() => [
              (targetType.value == 'COLLECTING')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    icon: _unref(RefreshRight),
                    plain: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("刷 新")
                    ]),
                    _: 1
                  }, 8, ["icon"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns[targetType.value], (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: item.prop,
              label: item.label,
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                (item.prop === 'earOrCollar')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(row.collarBarcode || row.earNo), 1)
                    ], 64))
                  : (item.dic)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(item.dic[row[item.prop]]), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(row[item.prop]), 1)
                      ], 64))
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "120",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetails(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": queryForm.pageIndex,
        "onUpdate:current-page": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.pageIndex) = $event)),
        "page-size": queryForm.pageSize,
        "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ]),
    _createVNode(_component_el_dialog, {
      center: "",
      modelValue: _unref(insureDawer),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(insureDawer) ? (insureDawer).value = $event : insureDawer = $event)),
      title: "验标详情",
      onClose: cancel,
      width: "75%",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        (_unref(insureDawer))
          ? (_openBlock(), _createBlock(viewDetail, {
              key: 0,
              onIsShowSure: isShowSure,
              onSetForm: setForm,
              form: _unref(auditForm),
              targetType: targetType.value,
              targetInfo: targetInfo,
              id: _unref(insureDetailId)
            }, null, 8, ["form", "targetType", "targetInfo", "id"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(insureDawer) //@ts-ignore
 ? insureDawer.value = false : insureDawer = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          }),
          (submitBtn.value && targetType.value == 'AuditPage')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: submitAudit,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("完成审核")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(dialogFormVisible))
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _unref(dialogFormVisible),
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(dialogFormVisible) ? (dialogFormVisible).value = $event : dialogFormVisible = $event)),
          title: "新建标的",
          width: "30%",
          "close-on-click-modal": false
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(dialogFormVisible) //@ts-ignore
 ? dialogFormVisible.value = false : dialogFormVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取 消")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (submitImg(ruleFormImgRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 确 定 ")
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _unref(form),
              ref_key: "ruleFormImgRef",
              ref: ruleFormImgRef,
              rules: rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "标的编码",
                  "label-width": formLabelWidth,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "自动填充",
                      disabled: ""
                    })
                  ]),
                  _: 1
                }),
                (verifyTargetOrCollar.value !== 'NONE')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: verifyTargetOrCollar.value === 'COLLAR' ? '登记号' : '登记号',
                      "label-width": formLabelWidth,
                      prop: "earNo",
                      required: verifyTargetOrCollar.value !== 'NONE'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(form).earNo,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).earNo) = $event)),
                          autocomplete: "off",
                          placeholder: getPlaceholder(),
                          maxlength: verifyTargetOrCollar.value === 'COLLAR' ? 30 : 32
                        }, null, 8, ["modelValue", "placeholder", "maxlength"])
                      ]),
                      _: 1
                    }, 8, ["label", "required"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "采集人",
                  "label-width": formLabelWidth,
                  prop: "collectUser"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(form).collectUser,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).collectUser) = $event)),
                      placeholder: "采集人",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collectList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.userName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (showField.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "畜龄（月）",
                      "label-width": formLabelWidth
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _unref(form).livestockAge,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).livestockAge) = $event)),
                          min: 1,
                          max: 10
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "正脸",
                  "label-width": formLabelWidth,
                  prop: "frontFaceIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      multiple: "",
                      "on-remove": (file, fileList) => handleremove('FACE', file, fileList)
            ,
                      action: '',
                      "http-request": uploadRequestFactory('FACE'),
                      "list-type": "picture-card",
                      "on-preview": handlePictureCardPreview
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-remove", "http-request"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "左侧脸",
                  "label-width": formLabelWidth,
                  prop: "LeftsideFaceIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      multiple: "",
                      "on-remove": (file, fileList) => handleremove('LEFT_FACE', file, fileList)
            ,
                      action: '',
                      "http-request": uploadRequestFactory('LEFT_FACE'),
                      "list-type": "picture-card",
                      "on-preview": handlePictureCardPreview
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-remove", "http-request"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "右侧脸",
                  "label-width": formLabelWidth,
                  prop: "RightsideFaceIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      multiple: "",
                      "on-remove": (file, fileList) => handleremove('RIGHT_FACE', file, fileList)
            ,
                      action: '',
                      "http-request": uploadRequestFactory('RIGHT_FACE'),
                      "list-type": "picture-card",
                      "on-preview": handlePictureCardPreview
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-remove", "http-request"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  multiple: "",
                  label: "鼻纹",
                  "label-width": formLabelWidth,
                  prop: "nosePrintIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      "on-remove": (file, fileList) => handleremove('NOSE', file, fileList)
            ,
                      action: '',
                      "http-request": uploadRequestFactory('NOSE'),
                      "list-type": "picture-card",
                      "on-preview": handlePictureCardPreview
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-remove", "http-request"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createVNode(_component_el_dialog, {
              modelValue: dialogVisible.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: dialogImageUrl.value,
                    alt: "Preview Image"
                  }, null, 8, _hoisted_7)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})